import React, { Component } from "react";
import "./index.less";

class App extends Component {
	state = {
        activeIndex: 0,
        tabChildren: [],
        extraChildren: [],
        tabItems: []
    }
    
    componentDidMount(){
        const { activeIndex } = this.props;
        this.setState({
            activeIndex: activeIndex || 0
        })
        this.getChildFromPorps(this.props);
    }

    componentWillReceiveProps(newProps){
        this.getChildFromPorps(newProps);
    }

    getChildFromPorps = (props) => {
        const { children } = props;
        let tabItems = [], tabChildren = [], extraChildren = [];
        children.map(item => {
            if(!item || !item.type) return false;
            if(item.props.tab){
                tabChildren.push(item);
                const childrenProps = item.props;
                tabItems.push({
                    text: childrenProps.tab,
                    props: childrenProps
                });
            }else{
                extraChildren.push(item);
            }
        })
        this.setState({
            tabItems,
            tabChildren,
            extraChildren
        })
    }

    switchTabs = (activeIndex = 0, e) => {
        const { tabChildren } = this.state;
        const currentTabChildren = tabChildren[activeIndex]
        if(currentTabChildren.props.disabled) return false;
        const { onTabChange } = this.props;
        if(activeIndex === this.state.activeIndex) return;
        this.setState({
            activeIndex
        }, () => {
            typeof onTabChange === "function" && onTabChange(activeIndex);
        })
        // 重置位置
        let el = e.target;
        let clientWidth = el.clientWidth,
            offsetLeft = el.offsetLeft,
            scrollLeft = el.parentNode.scrollLeft;
        if(offsetLeft <= scrollLeft){
            el.parentNode.scrollLeft = offsetLeft;
        }else if(offsetLeft + clientWidth - scrollLeft > window.innerWidth){
            el.parentNode.scrollLeft = offsetLeft + clientWidth - window.innerWidth;
        }
    }

    render() {
        const { activeIndex, tabItems, tabChildren, extraChildren } = this.state;
        const { wrapClass, tabBarExtraContent, tabExtraContent, themeColor, moblie, inkbarLeft } = this.props;

        return (
            <React.Fragment>
                {
                    moblie ?
                        <div className={"tabs-wrap-app" + (wrapClass ? " " + wrapClass : "")}>
                            <div className="tabs-item-wrap-app">
                                <div className="tabs-items-app">
                                    {
                                        tabItems.map((item, index) => (
                                            <div className="tabs-item-app"
                                                 style={{
                                                     color: activeIndex === index ? (themeColor || "#1890ff") : "",
                                                     display: item.props.hidden ? "none" : "block"
                                                 }}
                                                 onClick={(e) => this.switchTabs(index, e)} key={index}>
                                                {item.text}
                                            </div>)
                                        )
                                    }
                                </div>
                                <div className="tabs-ink-bar-app" style={{
                                    left: inkbarLeft + "px",
                                    background: themeColor
                                }}></div>
                                {/*<div className="tabs-ink-bar-app"></div>*/}
                                { tabBarExtraContent }
                            </div>
                            { tabExtraContent }
                            <div className="tabs-content-wrap-app">{tabChildren[activeIndex]}</div>
                        </div>
                        :
                        <div className={"tabs-wrap" + (wrapClass ? " " + wrapClass : "")}>
                            <div className="tabs-item-wrap">
                                <div className="tabs-items">
                                    {
                                        tabItems.map((item, index) => (
                                            <div className="tabs-item"
                                                 style={{
                                                     color: activeIndex === index ? (themeColor || "#1890ff") : "",
                                                     display: item.props.hidden ? "none" : "block"
                                                 }}
                                                 onClick={(e) => this.switchTabs(index, e)} key={index}>
                                                {item.text}
                                                {activeIndex === index ? <span style={{
                                                    borderTopColor: themeColor || "#1890ff"
                                                }}></span> : null}
                                            </div>)
                                        )
                                    }
                                </div>
                                {/*<div className="tabs-ink-bar"></div>*/}
                                { tabBarExtraContent }
                            </div>
                            { tabExtraContent }
                            <div className="tabs-content-wrap">{tabChildren[activeIndex]}</div>
                        </div>
                }

            </React.Fragment>
        );
    }
}

function TabPanel(props) {
    const { children, activeIndex, index, moblie } = props;

    return (
        <div className="tab-content">{children}</div>
    );
}

App.TabPanel = TabPanel;

export default App;
